import { useEffect, useState } from "react";
import { DocForm, UploadDocForm } from "../whatsapp/uploaddoc";
import { SelectFromItems } from "../utils/forms/select";
import { LoadingButton } from "@mui/lab";
import { openGlobalSnack } from "../utils/snack";
import { sendServerRequest } from "../../server/request";
import { CltPropostalCompleteInfo } from "./types";

export function CltDocPedency({setBlockOut,propostal,onUploaded}:{setBlockOut:Function,propostal:CltPropostalCompleteInfo,onUploaded:Function}){
    const [type,setDocType]=useState('RG');
    const [sendingForm,setSendingForm]=useState<null|FormData>(null);
    useEffect(()=>{
       setBlockOut(Boolean(sendingForm));
       if(!sendingForm)return;
       sendServerRequest("POST",`/server/clt/solvePendency/${propostal.id}`,sendingForm).then(e=>{
                   setSendingForm(null);
                   onUploaded();
              }).catch(e=>{
                   setSendingForm(null);
                   openGlobalSnack('Erro ao fazer upload dos arquivos','error');
              })
    },[sendingForm])
    return (<div>
        <div style={{marginTop:'20px',marginBottom:'20px'}}>
            <SelectFromItems disabled={Boolean(sendingForm)} items={['RG','CNH','CLT']} defaultValue="RG" onChangeItem={(v)=>setDocType(v)} label="Tipo de documento"/>
        </div>
        <form id='upload_docs_form'>
                    
                    <DocForm disabled={Boolean(Boolean(sendingForm))} type={type}/>
                    <div style={{marginTop:'60px'}}>
                    <LoadingButton loading={Boolean(Boolean(sendingForm))} onClick={uploadDocs} variant="contained" fullWidth>{`Adicionar Documento (${type})`}</LoadingButton>
                    </div>
               </form>
    </div>);

    function uploadDocs(){
            const form:any=document.getElementById('upload_docs_form');
            if(!form)
                return;
            const sendForm=new FormData(form);
            const front:any=sendForm.get('doc_front');
            const back:any=sendForm.get('doc_back');
            if(!front||!front.name){
                openGlobalSnack('Insira a foto da frente do documento.','warning');
                return;
            }
            if(type!=='CNH'&&(!back||!back.name)){
                openGlobalSnack('Insira a foto de trás do documento.','warning');
                return;
            }
            setBlockOut(true);
            setSendingForm(sendForm);
    }
}